type Props = {};

export default function EditProfileTestPage({...props}: Props) {
  return <div>Testing</div>;
}
